    <h2>Reference and Notes</h2>
    <div fxLayout="column" fxLayoutGap="10px">
        <!-- reference -->
        <div class="reference">
            <div>
                <label *ngIf="slideshow.assignment.reference">Reference</label>
                <span [innerHtml]="linkService.linkify(slideshow.assignment.reference)"></span>
            </div>
            <mat-form-field *ngIf="(permissionsService.userHasPermission(Permissions.EditReferences) || !slideshow.locked)" floatLabel="never">
                <input 
                    matInput 
                    name="detailsTabReference" 
                    autocomplete="detailsTabReference"
                    id="detailsTabReference{{detailsTabReference}}"
                    placeholder="Reference" 
                    [(ngModel)]="slideshow.assignment.reference"
                    [readonly]="(!permissionsService.userHasPermission(Permissions.EditReferences) || slideshow.locked)">
            </mat-form-field>
        </div>

        <!-- notes -->
        <notes-component 
            #notes
            [assignment]="slideshow" 
            [(id)]="slideshow.assignment.id">
        </notes-component>       
            
    </div>
    <h2 *ngIf="slideshow.assignment.childType == 'slideshow' || slideshow.assignment.childType == 'rsoc'">AI Prompt</h2>
    <div 
        *ngIf="slideshow.assignment.childType == 'slideshow' || slideshow.assignment.childType == 'rsoc'" 
        fxLayout="column" 
        fxLayoutGap="10px">
        <!-- prompt -->
        <div class="prompt">
            <div [ngClass]="{'prompt-used': !slideshow.locked}">
                <label>Prompt</label>
                <span class="greyed-out" [innerHtml]="slideshow.assignment.mlPrompt !== '' ? slideshow.assignment.mlPrompt : 'N/A'"></span>
            </div>
            <ml-assignment-component 
                [slideshow]="slideshow"
                *ngIf="!slideshow.locked && permissionsService.userHasPermission(Permissions.UseAiPrompt)">
            </ml-assignment-component>
        </div>
    </div>
    <h2>Article Details</h2>
    <div fxLayout="row" fxLayoutWrap layoutAlign="start end" fxLayoutGap="10px">
        <!-- team -->
        <team-component 
            [(team)]="teamService.team"
            (teamChanged)="updateTeam($event, slideshow.assignment)"
            [canEdit]="(userCanEdit && !slideshow.locked)">
        </team-component>

    </div>
    
    <div class="messages">
        <div *ngFor="let message of slideshow.messages"><mat-icon class="warning">error_outline</mat-icon> {{message}}</div>
    </div>    

    <div fxLayout="row" fxLayoutWrap layoutAlign="start end" fxLayoutGap="10px">

        <!-- due date -->
        <mat-form-field>
            <input matInput 
                name="detailsTabDueDate"
                autocomplete="detailsTabDueDate" 
                id="detailsTabDueDate{{detailsTabDueDate}}"
                [min]="minDate"
                [matDatepicker]="picker" 
                placeholder="Due Date" 
                [(ngModel)]="slideshow.assignment.dueDate" 
                [readonly]="(!permissionsService.userHasPermission(Permissions.EditDueDate) || slideshow.locked)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker [disabled]="(!userCanEdit || slideshow.locked)" #picker></mat-datepicker>
        </mat-form-field>

        <!-- target publish date -->
        <mat-form-field>
            <input matInput 
                name="detailsTabTargetPublishDate" 
                autocomplete="detailsTabTargetPublishDate"
                id="detailsTabTargetPublishDate{{detailsTabTargetPublishDate}}"
                [formControl]="targetDateControl"
                [matDatepicker]="picker2" 
                placeholder="Target Publish Date"  
                [readonly]="(!permissionsService.userHasPermission(Permissions.EditTargetPublishDate) || slideshow.locked)"
                [min]="minDate">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker [disabled]="(!userCanEdit || slideshow.locked)" #picker2></mat-datepicker>
        </mat-form-field>

    </div>

    <div fxLayout="row" fxLayoutWrap layoutAlign="start end" fxLayoutGap="10px">
        <!-- slide count -->
        <slideCount-component [(value)]="slideshow.assignment.slideCount" [canEdit]="(permissionsService.userHasPermission(Permissions.EditSlideCount) && !slideshow.locked)"></slideCount-component>

        <!-- slide word count -->
        <slideWordCount-component *ngIf="!slideshow.quiz" [(value)]="slideshow.assignment.slideWordCount" [canEdit]="(permissionsService.userHasPermission(Permissions.EditSlideWordCount) && !slideshow.locked)"></slideWordCount-component>
        
        <!-- priority -->
        <priority-component [(value)]="slideshow.assignment.priority" [canEdit]="(permissionsService.userHasPermission(Permissions.EditPriority) && !slideshow.locked)"></priority-component>
        
        <!-- quizType -->
        <quiz-type-component *ngIf="slideshow.quiz" [(quizType)]="slideshow.assignment.quizType" [canEdit]="(permissionsService.userHasPermission(Permissions.EditQuizType) && !slideshow.locked)"></quiz-type-component>

        <!-- abbreviation -->
        <mat-form-field>
            <input matInput 
                name="detailsTabAbbr"
                autocomplete="detailsTabAbbr" 
                id="detailsTabAbbr{{detailsTabAbbr}}"
                placeholder="Ad Acronym" 
                [(ngModel)]="slideshow.assignment.abbreviation" 
                [readonly]="(!permissionsService.userHasPermission(Permissions.EditAbbreviation) || slideshow.locked)">
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutWrap layoutAlign="start" fxLayoutGap="10px" *ngIf="slideshow.assignment.childType != 'quiz'">
        <!-- intro -->
        <intro-outro-component
            fxLayout="column"
            [(count)]="slideshow.assignment.introWordCount"
            [(checked)]="slideshow.assignment.intro"
            title="Intro"
            (checkedChange)="introChange($event, 'intro')"
            [canEdit]="(permissionsService.userHasPermission(Permissions.EditIntroWordCount) && !slideshow.locked)">
        </intro-outro-component>
        
        <!-- outro -->
        <intro-outro-component
            fxLayout="column"
            [(count)]="slideshow.assignment.outroWordCount"
            [(checked)]="slideshow.assignment.outro"
            title="Outro"
            (checkedChange)="introChange($event, 'outro')"
            [canEdit]="(permissionsService.userHasPermission(Permissions.EditOutroWordCount) && !slideshow.locked)">
        </intro-outro-component>

        <!-- narrative -->
        <div fxLayout="column">
            <mat-checkbox 
                class="mat-form-field-infix" 
                name="narrative" 
                [(ngModel)]="slideshow.assignment.narrative" 
                [disabled]="(!permissionsService.userHasPermission(Permissions.EditNarrativeState) || slideshow.locked)">
                Narrative
            </mat-checkbox>
        </div>

        <!-- n2s -->
        <div fxLayout="column">
            <mat-checkbox 
                class="mat-form-field-infix" 
                name="n2s" 
                [(ngModel)]="slideshow.assignment.n2s" 
                [disabled]="(!permissionsService.userHasPermission(Permissions.EditN2SState) || slideshow.locked)">
                N2S
            </mat-checkbox>
        </div>
    </div>

    <!-- affiliates -->
    <affiliates-component  
        [canEdit]="(permissionsService.userHasPermission(Permissions.EditAffiliatesState) && !slideshow.locked)"
        [(affiliates)]="slideshow.assignment.affiliates"
        [(affiliated)]="slideshow.assignment.affiliated">
    </affiliates-component>
    
    <h2>Page Additions</h2>
    <!-- page additions writer -->
    <page-add-writer-component 
        [canEdit]="(permissionsService.userHasPermission(Permissions.AddPageAdditions) && !slideshow.locked)"
        [(team)]="teamService.team"
        (teamChanged)="teamService.updateAssignment($event, slideshow.assignment)">
    </page-add-writer-component>

    <div fxLayout="row" fxLayoutGap="10px">
        <!-- due date -->
        <mat-form-field>
            <input matInput 
                name="detailsTabPageAddDate" 
                autocomplete="detailsTabPageAddDate"
                id="detailsTabPageAddDate{{detailsTabPageAddDate}}"
                [matDatepicker]="pageAddPicker" 
                placeholder="Due Date" 
                [(ngModel)]="slideshow.assignment.pageAddDate" 
                [readonly]="(!permissionsService.userHasPermission(Permissions.AddPageAdditions) || slideshow.locked)">
            <mat-datepicker-toggle matSuffix [for]="pageAddPicker"></mat-datepicker-toggle>
            <mat-datepicker [disabled]="(!userCanEdit || slideshow.locked)" #pageAddPicker></mat-datepicker>
        </mat-form-field>
        
        <!-- date -->
        <mat-form-field>
            <input matInput 
                name="detailsTabPageAddCount"
                autocomplete="detailsTabPageAddCount"
                id="detailsTabPageAddCount{{detailsTabPageAddCount}}"
                placeholder="Pages to Add" 
                [(ngModel)]="slideshow.assignment.pageAddCount" 
                [readonly]="(!permissionsService.userHasPermission(Permissions.AddPageAdditions) || slideshow.locked)">
        </mat-form-field>

        <div *ngIf="permissionsService.userHasPermission(Permissions.AddPageAdditions) && !slideshow.locked">
            <button class="button" (click)="slideshow.sendPageAdditions()">Send</button>  
            <span class="save-message" *ngIf="slideshow.sending">Sending</span>
        </div>
    </div>

    <div fxLayout="column" fxLayoutGap="10px">
        <!-- notes -->
        <notes-component [assignment]="slideshow.assignment" [(id)]="slideshow.assignment.id" reference="page-additions"></notes-component>
    </div>

    <!-- copy assignment -->
    <ng-container *ngIf="!slideshow.assignment?.cloneMaster">
        <h2>Copy Assignment</h2>
        <div class="clones">
            <label>Copy</label>
            <div *ngFor="let clone of slideshow.clones">
                <span *ngIf="!!clone.title">
                    <span class="abbr">{{clone.abbreviation}}</span>
                    <a class="title" [innerHTML]="clone.title" [href]="clone.id ? '/slideshow/' + clone.id : ''" target="_blank"></a>
                    <span class="sites">
                        <a 
                            *ngFor="let site of clone.sites; trackBy: utils.trackByIndex" 
                            title="{{site.domain}}" 
                            href="{{site?.permalink}}" 
                            target="_blank" 
                            class="site-{{site.abbreviation}}" 
                            [ngClass]="{primary: site.primary}">
                                {{site.abbreviation}}
                        </a>
                    </span> 
                    <span class="dropdown new-copy" *ngIf="userCanEdit && !slideshow.locked">
                        <button 
                            class="add-site faded trigger" 
                            (click)="slideshow.copy($event, clone.id)">
                            <mat-icon>add</mat-icon> New Copy From This Copy
                        </button>
                    </span>
                </span>
            </div>
            <div class="dropdown" *ngIf="userCanEdit && !slideshow.locked">
                <button 
                    class="add-site faded trigger" 
                    (click)="slideshow.copy($event)">
                    <mat-icon>add</mat-icon> New Copy
                </button>
            </div>
        </div>
    </ng-container>
    <!-- parent assignment -->
    <ng-container *ngIf="parentAssignment">
        <h2>Parent Assignment</h2>
        <div class="clones">
            <div>
                <span *ngIf="!!parentAssignment.title">
                    <span class="abbr">{{parentAssignment.abbreviation}}</span>
                    <a class="title" [innerHTML]="parentAssignment.title" [href]="parentAssignment.id ? '/slideshow/' + parentAssignment.id : ''" target="_blank"></a>
                    <span class="sites">
                        <a 
                            *ngFor="let site of parentAssignment.sites; trackBy: utils.trackByIndex" 
                            title="{{site.domain}}" 
                            href="{{site?.permalink}}" 
                            target="_blank" 
                            class="site-{{site.abbreviation}}" 
                            [ngClass]="{primary: site.primary}">
                                {{site.abbreviation}}
                        </a>
                    </span> 
                </span>
            </div>
        </div>
    </ng-container>
    <!-- original assignment -->
    <ng-container *ngIf="originalAssignment">
        <h2>Original Assignment</h2>
        <div class="clones">
            <div>
                <span *ngIf="!!originalAssignment.title">
                    <span class="abbr">{{originalAssignment.abbreviation}}</span>
                    <a class="title" [innerHTML]="originalAssignment.title" [href]="originalAssignment.id ? '/slideshow/' + originalAssignment.id : ''" target="_blank"></a>
                    <span class="sites">
                        <a 
                            *ngFor="let site of originalAssignment.sites; trackBy: utils.trackByIndex" 
                            title="{{site.domain}}" 
                            href="{{site?.permalink}}" 
                            target="_blank" 
                            class="site-{{site.abbreviation}}" 
                            [ngClass]="{primary: site.primary}">
                                {{site.abbreviation}}
                        </a>
                    </span> 
                </span>
            </div>
        </div>
    </ng-container>